//@ts-check

// External
import { useState } from "react"

// Internal
import useAsyncEffect from "./use-async-effect"
import { requestJSON } from "./request-module"
import { getEndPoint } from "./endpoint"
import store, { qs } from "../store"

var userPromise
var getUseByCodePromise
export default function useIsLoggedIn() {
  const [isLoggedIn, setIsLoggedIn] = useState(false)
  const [userInfo, setUserInfo] = useState({email:null,name:null,picture:null,account_id:null,accountName:null,auth0Subscripton:false})
  const [checking, setChecking] = useState(true)

  
  useAsyncEffect(async () => {
    // configure({
    //   cookieDomain: window["config"].COOKIE_DOMAIN,
    //   cookiePrefix: window["config"].COOKIE_PREFIX,
    //   authDomain: window["config"].HOME_URL,
    //   fallbackRedirect: window.location.href,
    // })
    var {message,error_description,code}=qs()
    if(error_description) {
      store.auth_error=String(error_description)
      store.updateStore()
    }
    if(message) {
      store.auth_error=String(message)
      store.updateStore()
    }
    if(location.pathname=='/auth0_callback') {
      if(code) {
        if(!getUseByCodePromise) {
          getUseByCodePromise=fetch(getEndPoint() + '/get-user-by-code?code=' + code,{
            credentials:"include"
          })
        await getUseByCodePromise
        window.open('/v2/landing','_top')
        }
      }
    }
    if(!userPromise) {
      userPromise=  requestJSON("GET", "/user",null,true);
    }
    const userDetails = await userPromise
    if(!userDetails?.email) {
      setUserInfo({email:null,name:null,picture:null,auth0Subscripton:false,accountName:null,account_id:null})
      setIsLoggedIn(false)
      setChecking(false)
      return
    }
    userDetails.isLoggedIn=true
    setUserInfo({
      //@ts-ignore
      ...userDetails,
      auth0Subscripton: !!userDetails?.account_id
    })
    setChecking(false)
    setIsLoggedIn(userDetails)
  })
  return {
    userInfo,
    checking,
    isLoggedIn,
  }
}
